import React, { useCallback, useState } from 'react';
import { useFocusEffect } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import { useFriends } from '../store/friends';
import { friendArchive } from '../platform/social';
import { Caption, Section, ToggleRow } from './ui';
import { usePalette } from '../theme';

export default function FriendArchiveSettings() {
  const { t } = useTranslation(),
    p = usePalette();
  const overview = useFriends(s => s.overview),
    refresh = useFriends(s => s.refresh);
  const [error, setError] = useState(false);
  useFocusEffect(
    useCallback(() => {
      refresh().catch(() => {});
    }, [refresh]),
  );
  if (!overview?.started) return null;
  return (
    <Section>
      <ToggleRow
        label={t('relay.cloudArchive')}
        value={overview.cloudArchive}
        onChange={async enabled => {
          setError(false);
          try {
            await friendArchive(enabled);
            await refresh();
          } catch {
            setError(true);
          }
        }}
      />
      {overview.cloudArchive ? (
        <Caption>
          {t('relay.archiveUsage', {
            used: Math.ceil(overview.archiveBytes / (1024 * 1024)),

          })}
        </Caption>
      ) : null}
      {error ? <Caption color={p.danger}>{t('relay.archiveError')}</Caption> : null}
    </Section>
  );
}
